import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { catchError, map, of, switchMap, take } from 'rxjs';
import { CropFieldNutrientCalculationsResponse } from 'src/app/bem/shared/models/models';
import { BemApiService } from 'src/app/bem/shared/services/bem-api.service';
import { selectCropYear } from 'src/app/store/selectors';

import { extractCropFieldNutrientCalculations } from 'src/app/bem/store/bfp.feature';

import { BemCropFieldSortingService } from '../services/bem-crop-field-sorting.service';

export const redirectToBemAdviceGuard: CanActivateFn = (_: ActivatedRouteSnapshot, __: RouterStateSnapshot) => {
  const router = inject(Router);
  const bemCropFieldSortingService = inject(BemCropFieldSortingService);
  const bemApiService = inject(BemApiService);
  const store = inject(Store);

  const handleCropFieldsNavigation = (cropFields: CropFieldNutrientCalculationsResponse[]) => {
    if (!cropFields || cropFields.length === 0) {
      return router.createUrlTree(['/']);
    }

    const filteredCropFields = cropFields.map((d) => extractCropFieldNutrientCalculations(d));
    const sortedFields = bemCropFieldSortingService.sortFields(filteredCropFields);

    if (sortedFields.length > 0) {
      const cropFieldId = sortedFields[0].id;
      return router.createUrlTree(['/bem', cropFieldId]);
    } else {
      return router.createUrlTree(['/']);
    }
  };

  return store.select(selectCropYear).pipe(
    take(1),
    switchMap((cropYear) => bemApiService.isBemCustomer(cropYear).pipe(
      switchMap(({ isBemCustomer }) => isBemCustomer
        ? bemApiService.getCropFieldNutrientCalculation(cropYear).pipe(map(handleCropFieldsNavigation))
        : of(router.createUrlTree(['/'])),
      ),
    )),
    catchError(() => of(router.createUrlTree(['/']))),
  );
};
